import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { PackingMethodAdapter } from './dto/packing-methods.adapter';
import { PackingMathodsController } from './packing-mathods.controller';
import { PackingMathodsService } from './packing-mathods.service';
import { PackingMethod } from './packing-methods.entity';

@Module({
  imports: [
    TypeOrmModule.forFeature([PackingMethod]),
  ],
  controllers: [PackingMathodsController],
  providers: [PackingMathodsService,PackingMethodAdapter,ApplicationExceptionHandler,LogsService]
})
export class PackingMathodsModule {}
